module.exports = __webpack_public_path__ + "assets/site-english.4502d0d8.pdf";